import { Ajax } from "../../Common/Ajax";
import { CookieHelper } from "../../Common/CookieHelper";
import { GlobalData } from "../../Common/GlobalData";
import { Notification, PortfolioGridField, PortfolioGridFilter, TemplateHelpers } from "../../Common/KendoHelpers";
import { MultiSourceAnalysis } from "../../MultiSource/MultiSourceAnalysis";

export class WatchAndReadyListsModel {
    Symbol: string | null = null;
    ReadyList: boolean | null = null;

    constructor(model: any = null) {
        if (model) {
            this.Symbol = model.symbol;
            this.ReadyList = model.readyList;
        }
    }
}

export class WatchList extends MultiSourceAnalysis {
    private static readonly NEW_WATCH_SYMBOL = '#newWatchSymbol';
    private static readonly CREATE_WATCH_BUTTON = '#createWatchButton';

    constructor() {
        super('#watchListGrid');
        this.init(GlobalData.URL_BASE +
            GlobalData.URL_SUFFIX_PORTFOLIO_WATCHLIST_MANAGER_WATCHLIST +
            '?watchListId=' +
            CookieHelper.get(GlobalData.WATCHLIST_MANAGER_WATCHLIST_ID_COOKIE));
    }

    protected override initFields() {
        super.initFields();

        this.fields['issueNo'] = new PortfolioGridField('issueNo');
        this.fields['readyList'] = new PortfolioGridField('readyList');
    }

    protected override getGridDataSource(): any {
        const baseDataSource = super.getGridDataSource();

        return {
            ...baseDataSource,
            schema: {
                ...baseDataSource.schema,
                model: {
                    ...baseDataSource.schema.model,
                    fields: {
                        ...baseDataSource.schema.model.fields,
                        issueNo: { type: 'number' },
                        readyList: { type: 'boolean' },
                    }
                }
            }
        };
    }

    protected override getGridOptions(dataSource: any): kendo.ui.GridOptions {
        const options = super.getGridOptions(dataSource);
        options.dataBound = () => {
            super.gridDataBound();

            $(this.gridId).show();
            this.switchCompanyAndIndustry(true);
        };

        options.columns!.push({
            field: this.fields['issueNo'].getName(),
            title: 'Issue',
            width: '4%',
            filterable: true,
            headerAttributes: { 'class': 'table-header-cell grid-header-12 table-header-cell-space-for-filter' },
            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
        }, {
            field: this.fields['readyList'].getName(),
            title: 'Like<br>List',
            width: '4%',
            filterable: true,
            headerAttributes: { 'class': 'table-header-cell grid-header-12 table-header-cell-space-for-filter' },
            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
            template: kendo.template(TemplateHelpers.getCheckboxTemplate('readyList')),
        }, {
            filterable: true,
            width: '3%',
            attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
            template: kendo.template(TemplateHelpers.getDeleteButtonTemplate('../images', 'symbol')),
        });

        return options;
    }

    protected override defineEvents() {
        super.defineEvents();

        // Update value of the field when user clicks a checkbox.
        $('.readyListCheckbox').off('click').on('click', (e: any) => {
            this.onReadyClick(e);
        });

        let deleteButtonClass = TemplateHelpers.getDeleteButtonClass();
        $('.' + deleteButtonClass).off('click').on('click', (e: any) => {
            this.onDeleteClick(e);
        });

        $(WatchList.CREATE_WATCH_BUTTON).off('click').on('click', () => {
            this.createItem();
        });
    }

    private createItem() {
        let model = new WatchAndReadyListsModel();
        model.Symbol = ($(WatchList.NEW_WATCH_SYMBOL).val() as string).toUpperCase();

        let success = () => {
            this.grid.dataSource.read();
        };

        let error = (x: any) => {
            var msg = new Notification();
            msg.error(x.responseJSON);
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_PORTFOLIO_WATCHLIST_MANAGER_WATCHLIST +
            '?watchListId=' +
            CookieHelper.get(GlobalData.WATCHLIST_MANAGER_WATCHLIST_ID_COOKIE),
            'POST', model, success, error);
    }

    private onReadyClick(e: any) {
        let dataItem = this.getClosestDataItem(e) as any;
        dataItem.readyList = e.target.checked;

        this.updateReady(dataItem);
    }

    private updateReady(dataItem: any) {
        let success = () => {
            this.grid.dataSource.read();
        };

        let error = (x: any) => {
            var msg = new Notification();
            msg.error(x.responseJSON);
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_PORTFOLIO_WATCHLIST_MANAGER_WATCHLIST +
            '?watchListId=' + CookieHelper.get(GlobalData.WATCHLIST_MANAGER_WATCHLIST_ID_COOKIE),
            'PUT', dataItem, success, error);
    }

    private onDeleteClick(e: any) {
        let deleteButtonClass = TemplateHelpers.getDeleteButtonClass();
        let symbol = e.currentTarget.id.substr(deleteButtonClass.length);

        kendo.confirm('Are you sure that you want to delete ' + symbol + '?')
            .then(() => {
                this.deleteRow(symbol);
            });
    }

    private deleteRow(symbol: string) {
        let success = () => {
            this.grid.dataSource.read();
        };

        let error = (x: any) => {
            var msg = new Notification();
            msg.error(x.responseJSON);
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_PORTFOLIO_WATCHLIST_MANAGER_WATCHLIST +
            '?watchListId=' + CookieHelper.get(GlobalData.WATCHLIST_MANAGER_WATCHLIST_ID_COOKIE) +
            '&symbol=' + symbol, 'DELETE', null, success, error);
    }

    private getClosestDataItem(e: any) {
        return this.grid.dataItem($(e.target).closest('tr'));
    }
}
